import axios from 'axios';
import tool from '@/utils/tool';
// const ACCESS_TOKEN = 'Access-Token';
import Cookies from "js-cookie";
import { message } from 'ant-design-vue';

const apiBaseUrls = {
  api1: 'https://i.zaimanhua.com/lpi/',
  api2: 'https://i.zaimanhua.com/api/',
};

// 创建一个函数用于生成 axios 实例，并传入接口类型参数
const createAxiosInstance = (apiType) => {
  const baseUrl = apiBaseUrls[apiType];
  if (!baseUrl) {
    throw new Error(`Invalid API type: ${apiType}`);
  }
  const instance = axios.create({
    baseURL: baseUrl,
    timeout: 120000,
  });

  // 请求拦截器
  instance.interceptors.request.use(config => {
    const token = Cookies.get("token");
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token;
    }
    config.headers.Platform = 'pc';
    return config;
  }, err => {
    console.log(err);
    return Promise.reject(err);
  });

  // 响应拦截器
  instance.interceptors.response.use(response => {
    const data = response.data;
    if (data && data.code === 401) {
      message.error(data.msg);
      setTimeout(() => {
        tool.remove('token');
      }, 1500);
    } else if (data.code === 403) {
      message.error(data.msg);
    } else if (response.data.code === 200) {
      return response.data;
    } else if (response.data.code === 500) {
      return response.data;
    } else {
      return response.data;
    }
  }, err => {
    console.log(err);
    return Promise.reject(err);
  });

  return instance;
};

export default createAxiosInstance;